var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  t: "1765177037781",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4724",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      d: "M789.333333 960H234.666667a64 64 0 0 1-64-64V128a64 64 0 0 1 64-64h405.333333l213.333333 213.333333v618.666667a64 64 0 0 1-64 64z",
      fill: "#43A047",
      "p-id": "4725"
    }, null, -1),
    createElementVNode("path", {
      d: "M853.333333 277.333333H640V64z",
      fill: "#C8E6C9",
      "p-id": "4726"
    }, null, -1),
    createElementVNode("path", {
      d: "M640 277.333333l213.333333 213.333334V277.333333z",
      fill: "#2E7D32",
      "p-id": "4727"
    }, null, -1),
    createElementVNode("path", {
      d: "M661.333333 490.666667H320v298.666666h384V490.666667h-42.666667z m-298.666666 42.666666h85.333333v42.666667h-85.333333v-42.666667z m0 85.333334h85.333333v42.666666h-85.333333v-42.666666z m0 85.333333h85.333333v42.666667h-85.333333v-42.666667z m298.666666 42.666667h-170.666666v-42.666667h170.666666v42.666667z m0-85.333334h-170.666666v-42.666666h170.666666v42.666666z m0-85.333333h-170.666666v-42.666667h170.666666v42.666667z",
      fill: "#E8F5E9",
      "p-id": "4728"
    }, null, -1)
  ]));
}
__name(render, "render");
const googleSheets = markRaw({ name: "custom-color-google-sheets", render });
export {
  googleSheets as default
};
//# sourceMappingURL=google-sheets.js.map
